import React, { useEffect } from 'react'
import { Container, Row, Col, Button } from 'react-bootstrap';
import './emergenci.css';
import { useEmergencyStore } from '../../../../store/useEmergencyStore';
import { useState } from 'react';
import Loader from '../../../Loader';

function EmergenciBanner() {
    const { banner, getBanner } = useEmergencyStore()
    const [loading, setLoading] = useState(false)

    const fetchBannerData = async () => {
        setLoading(true)
        await getBanner()
        setLoading(false)
    }

    useEffect(() => {
        if (!banner) {
            fetchBannerData()
        }
    }, [banner, getBanner])
    return (
        <div>
            <Loader loading={loading}>
                <div className="emergenci-banner-section" style={{
                    "--emergency-bg": banner?.image ? `url(${banner.image})` : ""
                }}>
                    <div className="emergenci-banner-overlay" />
                    <Container className="theme-container">
                        <Row className="align-items-center">
                            <Col md={8} lg={6}>
                                <div className='emergenci-banner-content'>
                                    <p className="section-subtitle mb-xl-2 mb-1">{banner?.subTitle}</p>
                                    <h2 className="section-sub-title mb-xl-3 mb-2 text-uppercase">
                                        {banner?.title}
                                    </h2>
                                    <p className="emergenci-banner-description fontsize-20">
                                        {banner?.description}
                                    </p>
                                </div>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </Loader>
        </div>
    )
}

export default EmergenciBanner
